import React from "react";
import ReactDOM from "react-dom";

class RendelesPortal extends React.Component {
  constructor(props) {
    super(props);

    this.containerEl = document.createElement("div");
    this.externalWindow = null;
    this.containerEl.className = "rendeles-portal";
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.containerEl);
  }

  copyStyles = (sourceDoc, targetDoc) => {
    Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
      if (styleSheet.href) {
        // for <link> elements loading CSS from a URL
        const newLinkEl = sourceDoc.createElement("link");

        newLinkEl.rel = "stylesheet";
        newLinkEl.href = styleSheet.href;
        targetDoc.head.appendChild(newLinkEl);
      } else if (styleSheet.cssRules && styleSheet.cssRules.length > 0) {
        // for <style> elements
        const newStyleEl = sourceDoc.createElement("style");

        Array.from(styleSheet.cssRules).forEach(cssRule => {
          // write the text of each rule into the body of the style element
          newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
        });

        targetDoc.head.appendChild(newStyleEl);
      }
    });
  };

  componentDidMount() {
    this.externalWindow = window.open(
      "",
      "",
      "width=1200,height=1920"
    );
    this.externalWindow.document.body.appendChild(this.containerEl);

    this.copyStyles(document, this.externalWindow.document);
  }

  componentWillUnmount() {
    this.externalWindow.close();
  }
}

export default RendelesPortal;
